document.addEventListener('DOMContentLoaded', function () {

  /* --- Load variant data --- */
  var variantsData = [];
  var variantsJson = document.getElementById('product-variants-json');
  if (variantsJson) {
    try { variantsData = JSON.parse(variantsJson.textContent); } catch (e) {}
  }

  /* --- Quantity buttons --- */
  var qtyMinus = document.getElementById('qty-minus');
  var qtyPlus = document.getElementById('qty-plus');
  var qtyInput = document.getElementById('qty-input');

  if (qtyMinus && qtyPlus && qtyInput) {
    qtyMinus.addEventListener('click', function () {
      var v = parseInt(qtyInput.value, 10);
      if (v > 1) qtyInput.value = v - 1;
    });
    qtyPlus.addEventListener('click', function () {
      qtyInput.value = parseInt(qtyInput.value, 10) + 1;
    });
  }

  /* --- Variant selection --- */
  document.querySelectorAll('.variant-option').forEach(function (btn) {
    btn.addEventListener('click', function () {
      // Toggle selected class within this option group
      var group = btn.closest('.product-variant-options');
      group.querySelectorAll('.variant-option').forEach(function (b) {
        b.classList.remove('selected');
      });
      btn.classList.add('selected');

      // Gather all selected options
      var selectedOptions = [];
      document.querySelectorAll('.product-variant-options').forEach(function (optGroup) {
        var selectedBtn = optGroup.querySelector('.variant-option.selected');
        if (selectedBtn) {
          selectedOptions.push(selectedBtn.dataset.value);
        } else {
          selectedOptions.push(null);
        }
      });

      // Find matching variant
      var matchedVariant = null;
      for (var i = 0; i < variantsData.length; i++) {
        var variant = variantsData[i];
        var match = true;
        for (var j = 0; j < selectedOptions.length; j++) {
          if (selectedOptions[j] === null || variant.options[j] !== selectedOptions[j]) {
            match = false;
            break;
          }
        }
        if (match) {
          matchedVariant = variant;
          break;
        }
      }

      if (matchedVariant) {
        // Update hidden variant ID
        var hiddenInput = document.getElementById('variant-id');
        if (hiddenInput) hiddenInput.value = matchedVariant.id;

        // Update price
        var priceEl = document.getElementById('product-price');
        if (priceEl) priceEl.textContent = matchedVariant.price_formatted;

        // Update compare-at price & badge
        var compareEl = document.getElementById('product-compare-price');
        var badgeEl = document.getElementById('product-badge');
        if (matchedVariant.compare_at_price > matchedVariant.price) {
          if (compareEl) {
            compareEl.textContent = matchedVariant.compare_at_price_formatted;
            compareEl.style.display = '';
          }
          if (badgeEl) {
            var discount = Math.round((matchedVariant.compare_at_price - matchedVariant.price) / matchedVariant.compare_at_price * 100);
            badgeEl.textContent = '-' + discount + '%';
            badgeEl.style.display = '';
          }
        } else {
          if (compareEl) compareEl.style.display = 'none';
          if (badgeEl) badgeEl.style.display = 'none';
        }

        // Update add-to-cart button
        var cartBtn = document.getElementById('add-to-cart-btn');
        if (cartBtn) {
          if (matchedVariant.available) {
            cartBtn.disabled = false;
            cartBtn.style.opacity = '';
            cartBtn.style.cursor = '';
            cartBtn.textContent = 'Lägg i varukorg';
          } else {
            cartBtn.disabled = true;
            cartBtn.style.opacity = '.5';
            cartBtn.style.cursor = 'not-allowed';
            cartBtn.textContent = 'Slutsåld';
          }
        }

        // Update SKU
        var skuEl = document.getElementById('product-sku');
        if (skuEl) skuEl.textContent = matchedVariant.sku || '';

        // Switch main image to variant image if available
        if (matchedVariant.featured_image) {
          var mainImg = document.getElementById('main-product-img');
          if (mainImg) mainImg.src = matchedVariant.featured_image;
        }

        // Update URL without reload
        var url = new URL(window.location);
        url.searchParams.set('variant', matchedVariant.id);
        window.history.replaceState({}, '', url.toString());
      }
    });
  });

  /* --- Image gallery --- */
  document.querySelectorAll('.product-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var mainImg = document.getElementById('main-product-img');
      var src = thumb.dataset.src;
      if (mainImg && src) {
        mainImg.src = src;
        document.querySelectorAll('.product-thumb').forEach(function (t) {
          t.classList.remove('active');
        });
        thumb.classList.add('active');
      }
    });
  });

  /* --- Add to cart (AJAX) --- */
  var addToCartForm = document.getElementById('add-to-cart-form');
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', async function (e) {
      e.preventDefault();
      var btn = document.getElementById('add-to-cart-btn');
      var variantId = document.getElementById('variant-id')?.value;
      var quantity = parseInt(qtyInput?.value || '1', 10);

      if (!variantId) return;

      btn.disabled = true;
      btn.textContent = 'Lägger till...';

      try {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: quantity })
        });

        if (res.ok) {
          btn.textContent = 'Tillagd i varukorg ✓';
          btn.style.background = '#2e7d32';
          updateCartCount();
          if (typeof window.showToast === 'function') {
            var productTitle = (document.querySelector('.product-title') || {}).textContent || '';
            window.showToast(productTitle.trim());
          }
          setTimeout(function () {
            // Restore button with current variant price
            var currentVariantId = document.getElementById('variant-id').value;
            btn.textContent = 'Lägg i varukorg';
            btn.style.background = '';
            btn.disabled = false;
          }, 2500);
        } else {
          btn.textContent = 'Försök igen';
          btn.disabled = false;
        }
      } catch (err) {
        btn.textContent = 'Försök igen';
        btn.disabled = false;
      }
    });
  }

  async function updateCartCount() {
    try {
      var res = await fetch('/cart.js');
      var cart = await res.json();
      var indicator = document.querySelector('.cartindicator');
      if (indicator) indicator.textContent = cart.item_count;
    } catch (err) {}
  }
});
